import {
  getVipPlansResponseType,
  LatestPlanResponse,
  PaymentMethodType,
} from 'lib/_types'
import { yayApi } from '../baseApi'

export const paymentApi = yayApi
  .enhanceEndpoints({
    addTagTypes: [
      'Payment',
      'Payment/Card',
      'Payment/Subscription',
      'Payment/Purchase',
    ],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getEmplProducts: build.query<any, void>({
        query: () => ({
          url: '/v1/web/products/empl',
        }),
        transformResponse: (response) => {
          return {
            ...response,
          }
        },
      }),
      getSquareEmplProducts: build.query<any, void>({
        // possibly to be deprecated
        query: () => ({
          url: '/v1/payment_gateway/square/products/empl',
        }),
        transformResponse: (response) => {
          return {
            ...response,
          }
        },
      }),
      getLatestEmplProductPurchase: build.query({
        providesTags: ['Payment/Purchase'],
        query: ({ paymentId, method }) => ({
          url: `/v1/web/payments/${paymentId}`,
          params: {
            payment_method: method ?? 'square',
          },
        }),
        transformResponse: (response) => {
          return {
            ...response,
          }
        },
      }),
      buyEmplProduct: build.mutation({
        invalidatesTags: ['Payment/Purchase'],
        query: ({ cardId, productId, method }) => ({
          url: `/v1/web/payments`,
          method: 'POST',
          data: {
            card_id: cardId ?? undefined,
            product_id: productId,
            payment_method: method ?? 'square',
          },
        }),
      }),
      getVipPlans: build.query<getVipPlansResponseType, void>({
        query: () => ({
          url: '/v1/payment_gateway/square/products/vip_plan',
        }),
        transformResponse: (response) => {
          return {
            ...response,
          }
        },
      }),
      getCards: build.query<any, void>({
        providesTags: ['Payment/Card'],
        query: () => ({
          url: '/v1/payment_gateway/square/cards',
        }),
      }),
      deleteCard: build.mutation({
        query: (id) => ({
          url: `/v1/payment_gateway/square/cards/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Payment/Card'],
      }),
      updateCardUseInPayment: build.mutation({
        invalidatesTags: ['Payment/Card'],
        query: (id) => ({
          url: `/v1/payment_gateway/square/cards/${id}/default`,
          method: 'PUT',
          data: {
            payment_method_types: ['card'],
          },
        }),
      }),
      getInvoices: build.query({
        /**
         * @param status - optional, allows client to filter only certain types of invoice
         * @param cursor - optional, provide with cursor from last request to get next page
         */
        query: ({ status, cursor }) => ({
          url: '/v1/payment_gateway/square/invoices',
          params: {
            status,
            cursor: cursor,
          },
        }),
      }),
      getSubscription: build.query<LatestPlanResponse, void>({
        query: () => ({
          url: '/v1/payment_gateway/square/subscriptions/latest',
        }),
        providesTags: ['Payment/Subscription'],
      }),
      scheduleSubscription: build.mutation({
        query: ({ subscriptionId, planId }) => ({
          url: `/v1/payment_gateway/square/subscriptions/${subscriptionId}/plan`,
          method: 'POST',
          data: {
            plan_variation_id: planId,
          },
        }),
        invalidatesTags: ['Payment/Subscription'],
      }),
      createSubscription: build.mutation({
        query: ({ planId, cardId }) => ({
          url: '/v1/payment_gateway/square/subscriptions',
          method: 'POST',
          data: {
            plan_variation_id: planId,
            card_id: cardId,
          },
        }),
        invalidatesTags: ['Payment/Subscription'],
      }),
      unSubscribe: build.mutation({
        query: ({ subscriptionId }) => ({
          url: `/v1/payment_gateway/square/subscriptions/${subscriptionId}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Payment/Subscription'],
      }),
      createNewCard: build.mutation({
        invalidatesTags: ['Payment/Card'],
        query: ({ nonce }) => ({
          url: '/v1/payment_gateway/square/cards',
          method: 'POST',
          data: {
            payment_token: nonce,
          },
        }),
      }),
      getPaymentMethods: build.query<Array<{ type: PaymentMethodType }>, void>({
        query: () => ({
          url: '/v1/web/payment_methods',
        }),
        transformResponse: (response) => {
          return response
        },
      }),
    }),
    overrideExisting: false,
  })

export const {
  useGetEmplProductsQuery,
  useBuyEmplProductMutation,
  useLazyGetLatestEmplProductPurchaseQuery,
  useGetVipPlansQuery,
  useGetCardsQuery,
  useLazyGetCardsQuery,
  useUpdateCardUseInPaymentMutation,
  useGetInvoicesQuery,
  useGetSubscriptionQuery,
  useLazyGetSubscriptionQuery,
  useCreateNewCardMutation,
  useCreateSubscriptionMutation,
  useDeleteCardMutation,
  useUnSubscribeMutation,
  useScheduleSubscriptionMutation,
  useGetPaymentMethodsQuery,
} = paymentApi
